import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import './ErrorMessage.scss';

const ErrorMessage = ({ msg }) => {
  return (
    <div className="form-error-msg">
      <Icon name="alert" width={16} className="form-error-msg__icon" />
      <span>{msg}</span>
    </div>
  );
};

export default ErrorMessage;
